/**
 * Route for `igaming-bank-transfer-e-wallet-crypto-disbursement`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBankTransferEWalletCryptoDisbursementPage } from "../features/igaming-bank-transfer-e-wallet-crypto-disbursement/IgamingBankTransferEWalletCryptoDisbursementPage";

export const igamingBankTransferEWalletCryptoDisbursementRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-bank-transfer-e-wallet-crypto-disbursement",
	component: IgamingBankTransferEWalletCryptoDisbursementPage,
});

export default igamingBankTransferEWalletCryptoDisbursementRoute;
